<div class="w-screen max-w-[300px]"></div>

<div class="grid">
  <div class="flex flex-col justify-between">
    <aux-file-manager-error-message [errorMessage]="errorMessage()" />
    <div>
      <div class="mb-4">
        <div class="mb-2 text-xs">Protocol Version (Optional)</div>
        <ng-select
          placeholder="Select"
          id="protocols"
          [formControl]="selectedProtocol"
          [appendTo]="'body'"
          [searchable]="true"
          [clearable]="true"
        >
          @for (protocol of this.protocolVersionOptions; track protocol) {
            <ng-option [value]="protocol.value">
              <span [title]="protocol.label">{{ protocol.label }}</span>
            </ng-option>
          }
        </ng-select>
      </div>

      <div
        class="btn--hyperlink mb-4 flex cursor-pointer justify-start"
        (click)="downloadSiteAmendmentTemplate()"
      >
        Download the template
      </div>

      <aux-file-manager
        #manager
        class="h-48"
        [fetchFilesOnInit]="false"
        [pathFn]="pathFn"
        [eager]="false"
        [metadata]="metadata"
        [showSuccessOnUpload]="true"
        [accept]="'.csv'"
        [extensions]="['text/csv']"
        [showSpecificError]="true"
      />
    </div>
  </div>

  <div></div>

  <div class="mt-4 max-h-60 overflow-auto">
    <aux-file-viewer
      [fileManager]="manager"
      [disableFirstFileMargin]="true"
      [onlyShowUploaded]="false"
    />
  </div>
</div>
